
































import Vue from "vue";
import Component from "vue-class-component";
import { Format } from "../core/helpers/formatHelper";
import { ShopService } from "../core/services/shopService";
import PopularProducts from "../components/popularProducts/popularProducts.vue";
import store from "../core/store";
import CtaButton from "../components/ctaButton/ctaButton.vue";
import {
  notifyPayment,
  isRedsysPopup,
  notifyOpenerPaymentAndClose,
} from "../core/embed";

@Component({
  components: { CtaButton, PopularProducts },
})
export default class PaymentOkPage extends Vue {
  error: string = "";

  async mounted() {
    // Popup de Redsys (embebido): avisa al iframe que lo abrió y se cierra; no renderiza.
    if (isRedsysPopup()) {
      notifyOpenerPaymentAndClose("ok", this.$route.query.id);
      return;
    }
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 500);
    new ShopService().removeCart();
    notifyPayment("ok");
  }

  getImagePath(img: string) {
    if (img === null || img === undefined || img === "") {
      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    }
    return store.state.settings.Uploads + "/" + img;
  }

  formatPrice(price: string) {
    return Format.formatCurrency(price);
  }
}
